import { env } from "@/src/env.mjs";
import { resolveDocsUrl } from "@/src/features/studio-docs/resolveDocsUrl";

/**
 * Weval Studio docs URL for an upstream langfuse.com docs path, or `null`
 * when Studio has no page for it (or no docs site is configured). Hide the
 * link on `null`; never fall back to langfuse.com.
 *
 * @example docsUrl("/docs/evaluation/overview")
 */
export function docsUrl(upstreamPath: string): string | null {
  return resolveDocsUrl(upstreamPath, {
    baseUrl: env.NEXT_PUBLIC_STUDIO_DOCS_BASE_URL,
  });
}

/**
 * `docsUrl` for optional `href?: string` props (help popups, table header
 * tooltips, onboarding actions) that already drop the link when `href` is
 * missing.
 */
export function docsHref(upstreamPath: string): string | undefined {
  return docsUrl(upstreamPath) ?? undefined;
}

/**
 * Appends "<separator><label> <url>" to a plain-text message when the docs
 * page resolves, and returns the message unchanged when it does not. For API
 * errors and log lines that used to end with a langfuse.com link.
 */
export function withDocsHint(
  message: string,
  upstreamPath: string,
  {
    label = "Docs:",
    separator = " ",
  }: { label?: string; separator?: string } = {},
): string {
  const url = docsUrl(upstreamPath);
  return url ? `${message}${separator}${label} ${url}` : message;
}
